import { Map } from 'immutable';

import {
  UPDATE_CONSIGNEE_STATUS_REQUEST,
  UPDATE_CONSIGNEE_STATUS_FAILURE,
  UPDATE_CONSIGNEE_STATUS_SUCCESS,
} from './action';

const initialState = Map({
  type: '',
  payload: [],
});

function reducer(state = initialState, action) {
  const { type } = action;

  if (type === UPDATE_CONSIGNEE_STATUS_REQUEST) {
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => true)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], []);
  }

  if (type === UPDATE_CONSIGNEE_STATUS_FAILURE) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], payload);
  }

  if (type === UPDATE_CONSIGNEE_STATUS_SUCCESS) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => true)
      .setIn(['payload'], payload);
  }

  return state;
}

export default reducer;
